import moment from "moment";
import i18n from '@/plugins/i18n';

export const dateFormatMoment = () => {
    return 'YYYY-MM-DD';
}

export const showTextPicker = (dateRange) => {
    if (dateRange.startDate && dateRange.endDate) {
        console.log(dateRange, 'showTextPicker');
        return moment(dateRange.startDate).format(dateFormatMoment()) + ' - ' + moment(dateRange.endDate).format(dateFormatMoment());
    } else {
        return "<span class='date-placeholder'>" + i18n.t("Order Date...") + "</span>";
    }
}


// WEBPACK FOOTER //
// ./src/components/tenancy/admin/settings/sale/sale-contact/assets/js/Params.js